module.exports = __webpack_public_path__ + "static/img/tit.d8301fc9.png";